export default "__VITE_ASSET__8FhRaISD__ 758w, __VITE_ASSET__XFZJR_rs__ 500w";